import { render, staticRenderFns } from "./alertDetailPop.vue?vue&type=template&id=71ad9308&scoped=true"
import script from "./alertDetailPop.vue?vue&type=script&setup=true&lang=js"
export * from "./alertDetailPop.vue?vue&type=script&setup=true&lang=js"
import style0 from "./alertDetailPop.vue?vue&type=style&index=0&id=71ad9308&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ad9308",
  null
  
)

export default component.exports